export const messages =  {
    required: 'Please fill in the required field.',
    email: 'Please enter a valid email address.',
    eightOrMore: '8 characters or longer.',
    combine: 'Combine upper and lowercase letters and numbers.',
    confirmation: 'Passwords do not match. Please try again.'
}